import React from 'react';
import { Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import ImageCaption from '../../SpecialImageCaption';
import Carousel from '../../../darkmatter/Carousel';
import IndicatorGroup from '../../../organisms/ImageCollection/components/IndicatorGroup';
import './SpecialCarousel.css';
import SpecialCategory from './SpecialCategory';
import { getCategoryNameFromItems } from '../utils';

class SpecialCarousel extends React.Component {
  renderContent(items) {
    const { autoScroll, showIndicator, groupByCategory, categories, precision } = this.props;
    return (
      <div style={{ overflowY: 'hidden', overflowX: 'hidden' }}>
        <div>
          <Carousel
            totalNumberOfItems={items.length}
            autoScroll={autoScroll}
            numberOfDisplayItems={3}
          >
            {({ currentIndex, changeCurrentIndex, getDisplayItemIndices }) => (
              <div>
                <Grid columns={3}>
                  {getDisplayItemIndices().map(index => (
                    <Grid.Column>
                      <ImageCaption
                        gatsbyImage={items[index].gatsbyImage}
                        image={items[index].image}
                        name={items[index].name}
                        description={items[index].description}
                        variations={items[index].variations}
                        precision={precision}
                        {...(!groupByCategory && {
                          category: getCategoryNameFromItems(items[index]._id, categories),
                        })}
                      />
                    </Grid.Column>
                  ))}
                </Grid>
                {showIndicator && (
                  <div className="special-carousel-center-indicator-groups">
                    <IndicatorGroup
                      images={items}
                      currentIndex={currentIndex}
                      changeCurrentIndex={changeCurrentIndex}
                    />
                  </div>
                )}
              </div>
            )}
          </Carousel>
        </div>
      </div>
    );
  }

  renderWithCategory() {
    const { items, categories } = this.props;

    return (
      <SpecialCategory specials={{ items, categories }}>
        {({ items }) => this.renderContent(items)}
      </SpecialCategory>
    );
  }

  renderWithoutCategory() {
    const { items } = this.props;

    return this.renderContent(items);
  }

  render() {
    const { groupByCategory, categories } = this.props;
    return groupByCategory && categories.length
      ? this.renderWithCategory()
      : this.renderWithoutCategory();
  }
}

SpecialCarousel.propTypes = {
  items: PropTypes.array.isRequired,
  categories: PropTypes.array,
  groupByCategory: PropTypes.bool,
  autoScroll: PropTypes.bool,
  showIndicator: PropTypes.bool,
};

SpecialCarousel.defaultProps = {
  categories: [],
  autoScroll: true,
  showIndicator: true,
  groupByCategory: false,
};

export default SpecialCarousel;
